import { render, staticRenderFns } from "./Developing.vue?vue&type=template&id=b42c2ffa&scoped=true&"
import script from "./Developing.vue?vue&type=script&lang=js&"
export * from "./Developing.vue?vue&type=script&lang=js&"
import style0 from "./Developing.vue?vue&type=style&index=0&id=b42c2ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42c2ffa",
  null
  
)

export default component.exports